import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState, TListId } from '../../../types/types';
import { cardsArchive } from '../card/card/cardsArchive';
import { getListCardIdsByStatus } from '../../../store/model/selectors/getListCardIdsByStatus';
import { TStatus } from '../../../types/model';
import { listSetStatus } from './listSetStatus';

export const listArchive = (
    listId: TListId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const cardIds = getListCardIdsByStatus(state, listId, TStatus.STATUS_ACTIVE);
        return dispatch(cardsArchive(cardIds))
            .then(() => {
                return dispatch(listSetStatus(listId, TStatus.STATUS_ARCHIVE))
            })
    };
    return action;
};
